/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@/api/common/client';
import type {
  GetExportPlanQueryResponse,
  GetExportPlanQueryParams,
} from '../models/GetExportPlan.ts';
import type { RequestConfig, ResponseErrorConfig } from '@/api/common/client';
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { getExportPlanQueryResponseSchema } from '../zod/getExportPlanSchema.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const getExportPlanQueryKey = (params: GetExportPlanQueryParams) =>
  [{ url: '/api/export/plan' }, ...(params ? [params] : [])] as const;

export type GetExportPlanQueryKey = ReturnType<typeof getExportPlanQueryKey>;

/**
 * {@link /api/export/plan}
 */
export async function getExportPlan(
  params: GetExportPlanQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetExportPlanQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: `/api/export/plan`,
    params,
    ...requestConfig,
  });
  return getExportPlanQueryResponseSchema.parse(res.data);
}

export function getExportPlanQueryOptions(
  params: GetExportPlanQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = getExportPlanQueryKey(params);
  return queryOptions<
    GetExportPlanQueryResponse,
    ResponseErrorConfig<Error>,
    GetExportPlanQueryResponse,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return getExportPlan(params, config);
    },
  });
}

/**
 * {@link /api/export/plan}
 */
export function useGetExportPlan<
  TData = GetExportPlanQueryResponse,
  TQueryData = GetExportPlanQueryResponse,
  TQueryKey extends QueryKey = GetExportPlanQueryKey,
>(
  params: GetExportPlanQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetExportPlanQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? getExportPlanQueryKey(params);

  const query = useQuery(
    {
      ...getExportPlanQueryOptions(params, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
